import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-star-rating',
  templateUrl: './custom-star-rating.component.html',
  styleUrls: ['./custom-star-rating.component.scss']
})
export class CustomStarRatingComponent implements OnInit {

  @Input() rating: number;
  starArray:string[] = [];

  ngOnInit(): void {
    let stars = Math.round(this.rating * 2) / 2;
    if(stars !== 0) {
      var i = stars - (stars % 1);

      while (i--) {
        this.starArray.push('fa-star');
      }

      if (stars % 1 > 0) {
        this.starArray.push('fa-star-half-o');
      }

      while(this.starArray.length < 5) {
        this.starArray.push('fa-star-o');
      }
    }
  }
}
